export const company = {
  SVET_ROVNATEK: "344aa4a8-9f65-4a9d-b752-1dea22917d65",
  DENTA_LABS: "dd252385-8a8e-4272-81cd-e1e1d9e8a41b",
};

const companyByHostname = {
  "dev.labs1503.topmonks.com": company.SVET_ROVNATEK,
  "stage.labs1503.topmonks.com": company.SVET_ROVNATEK,
  "labs1503.topmonks.com": company.SVET_ROVNATEK,

  "dev.denta-labs1503.topmonks.com": company.DENTA_LABS,
  "stage.denta-labs1503.topmonks.com": company.DENTA_LABS,
  "denta-labs1503.topmonks.com": company.DENTA_LABS,
};

export function getCompanyByHostname(hostname) {
  return companyByHostname[hostname] ?? company.SVET_ROVNATEK;
}
